import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import common from './modules/common'
import tags from './modules/tags'
import errLog from './modules/errLog'
import getters from './getters'
import table from './modules/table'
import treeStore from './modules/tree'
import agreement from './modules/agreement'
import code from './modules/code'
import form from './modules/form'



Vue.use(Vuex)
const store = new Vuex.Store({
  modules: {
    user,
    common,
    errLog,
    tags,
    table,
    treeStore,
    agreement,
    code,
    form
  },
  getters,
})

export default store
